export const OPEN_WORKFLOW_PANEL_FIELD_GROUP = 'RD2.DecisionSupportWorkflowPanelFieldConfiguration';

export const OPEN_WORKFLOW_PANEL_FIELD_COMPLETION_DATE = `${OPEN_WORKFLOW_PANEL_FIELD_GROUP}.CompletionDate`;
export const OPEN_WORKFLOW_PANEL_FIELD_CREATED_BY = `${OPEN_WORKFLOW_PANEL_FIELD_GROUP}.CreatedBy`;
export const OPEN_WORKFLOW_PANEL_FIELD_PRODUCT_INSTANCE = `${OPEN_WORKFLOW_PANEL_FIELD_GROUP}.ProductInstance`;
export const OPEN_WORKFLOW_PANEL_FIELD_APPOINTMENT_DATE = `${OPEN_WORKFLOW_PANEL_FIELD_GROUP}.AppointmentDate`;
export const OPEN_WORKFLOW_PANEL_FIELD_QUESTIONS_AND_ANSWERS = `${OPEN_WORKFLOW_PANEL_FIELD_GROUP}.QuestionsAndAnswers`;

